// Style Profile V1 experiment (STYLE-PROFILE-SPEC.md). Rollback = set false and deploy.
export const STYLE_PROFILE_V1 = true;
